import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import "../../../pages/dashboard/Analytics.css";
import "../../../components/Pagination/Pagination.css";

class Pagination extends Component {
  generateWindowedPages = () => {
    const { currentPage, totalPageNumber, handlePageNavigation } = this.props;
    const pageWindow = 5;
    const pages = [];

    const startPage = Math.max(currentPage - pageWindow, 1);
    const endPage = Math.min(currentPage + pageWindow, totalPageNumber);

    if (startPage > 1) {
      pages.push(
        <li key="first" className="page-item">
          <span
            className="page-link"
            onClick={() => handlePageNavigation("first")}
          >
            1
          </span>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="ellipsis-start" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${
            this.props.currentPage === i ? "active" : ""
          }`}
        >
          <span
          style={{cursor: "pointer"}}
            className="page-link"
            onClick={() => this.props.handlePageNavigation(i)}
          >
            {i}
          </span>
        </li>
      );
    }

    if (endPage < totalPageNumber) {
      if (endPage < totalPageNumber - 1) {
        pages.push(
          <li key="ellipsis-end" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li key="last" className="page-item">
          <span
            className="page-link"
            onClick={() => handlePageNavigation("last")}
          >
            {totalPageNumber}
          </span>
        </li>
      );
    }

    return pages;
  };

  render() {
    const {
      currentPage,
      totalPageNumber,
      handlePageNavigation,
      handleRecordCountChange,
      recordCount,
      totalRecords,
    } = this.props;

    return (
      <div>
        <Row className="mt-4 mb-3">
          <Col className="text-left">
            <span className="showpageCount">{`Total records : ${totalRecords}`}</span>
          </Col>
          <Col className="text-center">
            <span className="showpageCount">{`Showing Page ${currentPage} of ${totalPageNumber ||
              1}`}</span>
          </Col>
          <Col className="text-right">
            <select
              className="selectscrol"
              onChange={handleRecordCountChange}
              value={recordCount}
            >
              <option value="10">10 rows</option>
              <option value="20">20 rows</option>
              <option value="30">30 rows</option>
              <option value="40">40 rows</option>
              <option value="50">50 rows</option>
            </select>
          </Col>
        </Row>

        <Row className="pagination">
          <nav aria-label="Page navigation example" className="text-center">
            <ul className="pagination">
              <li
                className={`page-item previousBtnArrow ${
                    currentPage <= 1 ? "disabledLiElement" : ""
                    }`}
                    >
                <span
                  style={{cursor: "pointer"}}
                  className="page-link previousBtnArrow"
                  onClick={() => handlePageNavigation("previous")}
                ></span>
              </li>
              <li
                className={`page-item previousBtn ${
                    currentPage <= 1 ? "disabledLiElement" : ""
                    }`}
                    >
                <span
                  style={{cursor: "pointer"}}
                  className="page-link"
                  onClick={() => handlePageNavigation("previous")}
                >
                  Previous
                </span>
              </li>

              {this.generateWindowedPages()}

              <li
                className={`page-item nextBtn ${
                    currentPage >= totalPageNumber ? "disabledLiElement" : ""
                    }`}
                    >
                <span
                  style={{cursor: "pointer"}}
                  className="page-link"
                  onClick={() => handlePageNavigation("next")}
                >
                  Next
                </span>
              </li>
              <li
                className={`page-item nextBtnArrow ${
                    currentPage >= totalPageNumber ? "disabledLiElement" : ""
                    }`}
                    >
                <span
                  style={{cursor: "pointer"}}
                  className="page-link nextBtnArrow"
                  onClick={() => handlePageNavigation("next")}
                ></span>
              </li>
            </ul>
          </nav>
        </Row>
      </div>
    );
  }
}

export default Pagination;
